// This file contains utility functions
import type { AutoRechargeFormValues } from './type';

export const normalizeNumber = (value: string = ''): number | undefined => {
  const num = Number(value);
  return Number.isNaN(num) ? undefined : num;
};

export const isTopUpConfigChange = (balanceThresholdCents: string, rechargeAmountCents: string, values: AutoRechargeFormValues): boolean => {
  const currentBalance = normalizeNumber(values.balanceThreshold);
  const initialBalance = normalizeNumber(balanceThresholdCents);
  const currentRecharge = normalizeNumber(values.rechargeAmount);
  const initialRecharge = normalizeNumber(rechargeAmountCents);

  const balanceChanged = currentBalance !== undefined && initialBalance !== undefined && currentBalance !== initialBalance;
  const rechargeChanged = currentRecharge !== undefined && initialRecharge !== undefined && currentRecharge !== initialRecharge;

  return balanceChanged || rechargeChanged;
};

export const sanitizeInputNumber = (value: string): string => {
  // Only allow numbers and decimal point
  const sanitizedValue = value.replace(/[^\d.]/g, '');

  // Prevent multiple decimal points
  const decimalCount = (sanitizedValue.match(/\./g) || []).length;
  let cleanValue = sanitizedValue;

  if (decimalCount > 1) {
    const firstDecimalIndex = sanitizedValue.indexOf('.');
    cleanValue =
      sanitizedValue.slice(0, Math.max(0, firstDecimalIndex + 1)) + sanitizedValue.slice(Math.max(0, firstDecimalIndex + 1)).replace(/\./g, '');
  }

  // If current value is "0" and user is typing a digit (not decimal), replace it
  if (cleanValue === '0' || (cleanValue.startsWith('0') && cleanValue.length > 1 && !cleanValue.includes('.'))) {
    const newValue = cleanValue.replace(/^0+/, '');
    return newValue || '0';
  }

  return cleanValue;
};
